<template>
  <v-card class="rounded-lg pa-2" elevation="2">
    <slot name="header"></slot>
    <v-data-table v-bind="tableProps" v-on="$listeners">
      <template v-for="(_, name) in tableSlots" v-slot:[name]="slotData">
        <slot :name="name" v-bind="slotData || {}" />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'CrudGrid',
  inheritAttrs: false,
  props: {
    footerText: { type: String, default: 'Itens por Página' },
  },
  computed: {
    tableProps() {
      return {
        ...this.$attrs,
        footerProps: { 'items-per-page-text': this.footerText },
      };
    },
    tableSlots() {
      const slots = { ...this.$scopedSlots };
      delete slots.header;
      return slots;
    },
  },
};
</script>
